import React from 'react';
import { ArrowLeft } from 'react-bootstrap-icons';

const SectionHeader = ({ 
  title, 
  icon, 
  onBackClick, 
  backText = "Back to Dashboard",
  description = "Manage and configure your reports and recommendations",
  size = "h2"
}) => {
  const HeaderTag = size;
  
  return (
    <div className="section-header">
      <div className="section-header-content">
        <div className="section-header-left">
          {icon && (
            <div className="section-header-icon">
              {icon}
            </div>
          )}
          <div className="section-header-text">
            <HeaderTag>{title}</HeaderTag>
            {description && <p>{description}</p>}
          </div>
        </div>
        <button className="back-button" onClick={onBackClick}>
          <ArrowLeft />
          {backText}
        </button>
      </div>
    </div>
  );
};

export default SectionHeader; 